var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6328 12.4609C15.1047 12.4609 17.9185 9.775 17.9185 6.46094C17.9185 3.14688 15.1047 0.460938 11.6328 0.460938C8.16094 0.460938 5.3471 3.14688 5.3471 6.46094C5.3471 9.775 8.16094 12.4609 11.6328 12.4609ZM9.38862 14.7109C4.55156 14.7109 0.632812 18.4516 0.632812 23.0688C0.632812 23.8375 1.28594 24.4609 2.09129 24.4609H21.1743C21.9797 24.4609 22.6328 23.8375 22.6328 23.0688C22.6328 18.4516 18.7141 14.7109 13.877 14.7109H9.38862Z",
    fill: "#212737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid);
export default __webpack_public_path__ + "static/media/user-solid.accbc190a44936af3bc411d3e219d999.svg";
export { ForwardRef as ReactComponent };